import * as React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { BuilderComponent } from '@builder.io/react';
import { makeStyles } from '@material-ui/core/styles';
import Link from '../components/link/link';
import '../../builder-setting';
import Header from '../components/header';
import { Box } from '@material-ui/core';
import { BacklinkingFooter } from '../features/backlinking-footer/backlinking-footer';

const useStyles = makeStyles(({spacing}) => ({
  root: {
  },
  header: {
  },
  footer: {},
  content: {}
}));

const query = graphql`
  query {
    allBuilderModels {
      header(limit: 1, options: { cachebust: true }) {
        content
      }
      footer(limit: 1, options: { cachebust: true }) {
        content
      }
    }
  }
`;

interface Props {
  children: React.ReactNode
}

export const PageLayout:React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  return (
    <StaticQuery query={query}>
      {data => {
        const models = data.allBuilderModels;
        const header = models.header[0].content;
        const footer = models.footer[0].content;
        return (
          <div className={classes.root}>
            <div className={classes.header}>
              <Header/>
            </div>
            <div className={classes.content}>{children}</div>
            <div className={classes.footer}>
              {/* <BuilderComponent
                renderLink={Link}
                name="footer"
                content={footer}
              /> */}
              <BacklinkingFooter/>
            </div>
          </div>
        );
      }}
    </StaticQuery>
  );
}
